// MessageAttachments.jsx

import React from 'react';

// Utilities
import { resolveAttachmentViewModel } from './attachmentUtils';

// CSS
import './MessageAttachments.css';

// Components
import MessageAttachmentItem from './MessageAttachmentItem';

/**
 * MessageAttachments
 *
 * @returns {ReactNode} The rendered component.
 */
const MessageAttachments = React.memo(({
  attachments,
  attachmentNodesByKey,
  onOpenAttachmentNode,
}) => {

  if (!Array.isArray(attachments) || attachments.length === 0) {
    return null;
  }

  // ----- RENDER ----- //

  return (
    <div className="message-attachments">
      {attachments.map((attachment, index) => {
        const model = resolveAttachmentViewModel({ attachment, index, attachmentNodesByKey });
        if (!model) return null;

        return (
          <MessageAttachmentItem
            key={model.key}
            model={model}
            onOpenAttachmentNode={onOpenAttachmentNode}
          />
        );
      })}
    </div>
  );
});

// Dev Tools
MessageAttachments.displayName = 'MessageAttachments';

export default MessageAttachments;
